var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcLock(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 2C9.25 2 7 4.25 7 7V9H9V7C9 5.35 10.35 4 12 4C13.65 4 15 5.35 15 7V9H17V7C17 4.25 14.75 2 12 2Z",
    fill: "#424242"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18 22H6C4.9 22 4 21.1 4 20V11C4 9.9 4.9 9 6 9H18C19.1 9 20 9.9 20 11V20C20 21.1 19.1 22 18 22Z",
    fill: "#FB8C00"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12 17C12.8284 17 13.5 16.3284 13.5 15.5C13.5 14.6716 12.8284 14 12 14C11.1716 14 10.5 14.6716 10.5 15.5C10.5 16.3284 11.1716 17 12 17Z",
    fill: "#C76E00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcLock);
export default __webpack_public_path__ + "static/media/ic_lock.b19aa2cb9248ce341be3f0e2d4b1f392.svg";
export { ForwardRef as ReactComponent };